<template>
  <div class="navbar">
    <div class="goback">
      <svg-icon icon-class="logoEn"/>
    </div>
    <breadcrumb class="breadcrumb-container"/>
    <!-- 国际化 -->
    <div class="contact" style="color:#f8d3c0;margin-right:20px;cursor: pointer;" v-if="isShowLang">
      <el-dropdown trigger="click" class="lang-dropdown">
        <span class="el-dropdown-link">{{this.lang}}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item,index) in langChoice" :key="index" @click.native="langChoiceOne(item)">{{item.value}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item" trigger="hover">
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar">
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/en">
            <el-dropdown-item>
              Back to home
            </el-dropdown-item>
          </router-link>
          <router-link to="/personalEn">
            <el-dropdown-item>
              <span>Personal Center</span>
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item>
            <span @click="openExternal">Contact service</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">Log Out</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="Service-box" v-if="Service">
      <div class="Service-message">
        <div class="Service-message-box__header">
          <div class="Service-message-box__title">
            <span>About</span>
          </div>
          <button type="button" aria-label="Close" class="el-message-box__headerbtn" @click="closeService">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="Service-message-box__content">
          <div class="Service-message-box__container">
            <div class="Service-message-box__message">
              <p style="margin-bottom:20px;font-size:16px;">
                Shanghai Judao Net-Tech Co., Ltd.<br/>
                <span style="font-size:16px;color:#333">www.judaoedu.com</span>
              </p>
              <p style="margin-bottom:20px;font-size:16px;">
                Silversea Media (S) Pte. Ltd.<br/>
                <span style="font-size:16px;color:#333">www.silversea-media.com</span>
              </p>
              <p style="margin-bottom:8px;font-size:12px;color:#999;">
                Contact: +65 6920 8799<br/>
                Email: info@silversea-media.com
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="Service-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary messageBox-btnTEN" @click="closeService">
            <span>Confirm</span>
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Screenfull from '@/components/Screenfull'
import request from '@/utils/request'

export default {
  components: {
    Breadcrumb,
    Screenfull
  },
  computed: {
    ...mapGetters([
      // 'sidebar',
      'avatar',
      'device',
    ])
  },
  // 跳转首页刷新页面
  inject:['reload'],
  data(){
    return {
      isShowLang:false,
      Service:false,
      lang:'English',
      langChoice:[{
        value:'简体中文',
        label:'zh',
      },{
        value:'English',
        label:'en'
      }],
      isShowE:'',
      position:2,
      opened:true,
    }
  },
  created(){
    this.getinfo();
  },
  methods: {
    closeService(){
      this.Service = false;
    },
    // 语言选择
    langChoiceOne(item){
      if(item.label == 'en'){
        this.lang = 'English'
        this.$i18n.locale = 'en'
        localStorage.setItem('language','en')
        document.getElementById('titleId').innerHTML = 'VReaLab'
      }else if(item.label == 'zh'){
        this.lang = '简体中文'
        this.$i18n.locale = 'zh'
        localStorage.setItem('language','zh')
        this.$router.push({path:'/'})
        this.reload();
        document.getElementById('titleId').innerHTML = '3D仿真实验室'
      }
    },
    //获取info
    getinfo(){
      if(localStorage.getItem('language') == 'en'){
        this.lang = 'English'
        document.getElementById('titleId').innerHTML = 'VReaLab'
      }else if(localStorage.getItem('language') == 'zh'){
        this.lang = '简体中文'
        document.getElementById('titleId').innerHTML = '3D仿真实验室'
      }
      if(localStorage.getItem('langEn') == ''){
        this.isShowLang = false;
      }else if(localStorage.getItem('langEn') == 'en'){
        this.isShowLang = false;
      }else if(localStorage.getItem('langEn') == 'zh'){
        this.isShowLang = false;
      }
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
        this.isShowE = res.jwtUser.activity
      }).catch(err=>{
        this.$confirm('The current account is already logged in on another device, Or not in use time', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'messageBox-btnFEN',
          confirmButtonClass: 'messageBox-btnTEN',
          type: 'warning',
        }).then(() => {
          this.logout();
        }).catch(() => {
          this.logout();
        })
      })
    },
    // 活动入口
    entrance(){
      // 生产
      window.open("http://192.168.0.133:8001/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
      // 测试
      // window.open("http://221.231.139.161:8011/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
    },
    openExternal(){
      // 打开qq
      // window.open("http://wpa.qq.com/msgrd?v=3&uin=3512883254&site=qq&menu=yes","_blank")
      this.Service = true;
    },
    toSim(index){
      if(index == 1){
        this.$router.push({path:'/'})
        // this.switchs = '全部'
      }else if(index == 2){
        // this.switchs = '同步'
      }else if(index == 3){
        this.$router.push({path:'/explore'})
        // this.switchs = '探究'
      }else if(index == 4){
        this.$router.push({path:'/myEx'})
      }else if(index == 5){
        this.$router.push({path:'/recycle'})
      }
    },
    // 跳转首页刷新页面
    routerTo(){
      window.open("https://zibo.judaoedu.com/");
      // this.$router.push({path:'/'});
      // this.reload();
    },
    toggleSideBar() {
      // this.$store.dispatch('ToggleSideBar')
      this.opened=!this.opened
    },
    logout() {
        this.$store.dispatch('LogOut').then(() => {
         window.location.href="https://ziboedu.com.cn/portal/cas/ajax/logout.do?service=https://ziboedu.com.cn/portal"
        })
/*
      if(localStorage.getItem('language') == 'en'){
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index'});
          localStorage.setItem('language','en');
        }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index?lan=en'})
        }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index?lan=zh'})
        }
      }else if(localStorage.getItem('language') == 'zh'){
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index'});
        }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index?lan=en'})
        }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index?lan=zh'})
        }
      }
  */
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.Service-box{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0 , 0 , .5);
  z-index: 2010;
}
.Service-message{
  padding: 14px;
  display: inline-block;
  width: 420px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0 , 0 , .1);
  text-align: left;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Service-message-box__header{
  padding: 0;
  height: 42px;
  position: relative;
}
.Service-message-box__title{
  float: left;
  line-height: unset;
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  color: #333;
}
.Service-message-box__content{
  padding: 0;
  // margin-bottom: 8px;
  color: #666;
  font-size: 14px;
}
.Service-message-box__container{
  position: relative;
}
.Service-message-box__message{
  text-align: center;
}
.Service-message-box__message p{
  margin: 0;
}
.Service-message-box__btns{
  text-align: center;
}

.lang-dropdown{
  color: #fff;
}
.lang-dropdown:hover{
  color: #fff;
}
  @media screen and (min-width:769px) and (max-width: 1024px){
    .ques{
      display: none;
    }
  }
.goback{
  margin-left: -21px;
  height: 100%;
  float: left;
  width: 300px;
  display: none;
}
.switch{
  width: 50px;
  height: 100%;
  float: left;
  line-height: 60px;
}
.switch /deep/ .el-input__suffix{
  display: none;
}
.switch /deep/ .el-input--suffix .el-input__inner{
  padding: 0 10px;
  height: 30px;
  border-radius: 20px;
  border-color: #2174ff ;
  background-color: rgba(233, 238, 242, .4);
  color: rgb(240, 234, 234);
}
.svg-icon{
  width: 100% !important;
  height: 100% !important;
  padding-top: 2px;
  padding-bottom: 2px;
}
.header-tab{
  height: 100%;
  float: left;
  line-height: 60px;
  margin-left:0px;
  .tabitem{
    float:left;
    padding: 0 20px;
    color: #fff;
    cursor: pointer;
    font-size: 18px;
  }
  .tabitem:hover{
    // background-color: #fef7ed;
    color: #fff ;
  }
  .active{
    background-color: #fff;
    color: #2174ff ;
  }
  .active:hover{
    background-color: #fff;
    color: #2174ff ;
  }
}
// .goback img{
//   width: 120px;
//   height: 46px;
//   margin-top: 7px;
// }
.goback img{
  // width: 120px;
  // height: 46px;
  margin-top: 4px;
}
  .navbar {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;
    height: 60px;
     background:  #2174ff;
    border-bottom: 1px solid #549cff;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 60px;
      float: left;
      padding: 0 10px;
    }
   .app-breadcrumb.el-breadcrumb{
     display: none;
   }
    .breadcrumb-container{
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right;
      height: 100%;
      &:focus{
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international{
        vertical-align: top;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 60px;
        margin-right: 30px;
        .avatar-wrapper {
          margin-top: 9px;
          position: relative;
          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
.contact{
  position: absolute;
  right: 6%;
  top: 50%;
  transform: translateY(-50%);
}
.contact ul{
  list-style: none;
  margin: 0;
  padding: 0;
}
.contact ul li{
  color: #fff;
  border-right: 1px solid #eee;
  float:left;
  padding-right:5px;
  font-size: 12px;
}
.contact ul li:last-of-type{
  padding-left:5px;
  padding-right:none;
  border-right:none;
}
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #fff;
    color: #2174ff;
  }
  // .el-select-dropdown{
  //   margin-top: -8px !important;
  //   left: 170px !important;
  // }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color:#fff;
  }
  .el-select-dropdown__item.selected{
    color: #2174ff;
  }
@media (max-width: 1024px){
  .header-tab{
    margin-left: 0px;
  }
  .header-tab .tabitem{
    padding: 0 10px;
    font-size: 16px;
  }
  .goback{
    margin-left: 9px;
    height: 100%;
    float: left;
    width: 200px;
    display: none;
  }
  .contact{
    right: 7%;
  }
  .contact /deep/ .el-dropdown{
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/langHeaderEn.vue